<script>
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition'
  import { fly } from 'svelte/transition'
  import { quintOut } from 'svelte/easing'
  import { createPostRequest, createDeleteRequest } from '../../src/create_request'

  import { settings, cart } from '../../src/data_storage.js'
  settings.useLocalStorage()
  cart.useLocalStorage()

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  import { _ } from 'svelte-i18n'
  import { formatCurrency } from '../../src/utils'
  import CheckoutIcon from './svg/checkout.svelte'
  import RemoveIcon from './svg/remove.svelte'
  import Signup from '../signup.svelte'
  import Login from '../login.svelte'
  import CheckoutAddress from './checkout_address.svelte'
  import CheckoutDelivery from './checkout_delivery.svelte'
  import CheckoutPayment from './checkout_payment.svelte'
  import CheckoutSubmit from './checkout_submit.svelte'

  import { getContext } from 'svelte'

  export let shop
  export let signedIn
  export let showCart
  export let order_done_handler
  export let emptied_handler

  const { removeItem, cartTotal } = getContext('cart')

  let total = 0
  let itemsCount = 0
  const ACCOUNT = 'ACCOUNT'
  const ADDRESS = 'ADDRESS'
  const DELIVERY = 'DELIVERY'
  const PAYMENT = 'PAYMENT'
  const SUBMIT = 'SUBMIT'
  let checkoutStep = ADDRESS
  let doneAddress = false
  let doneDelivery = false
  let donePayment = false
  let donePaying = false
  let showSignup = false
  let showCheckout = false
  let cancelingCheckoutEnabled = true
  let empty = true
  let errors

  function mountFromData(data, pushState = false) {
    // console.log('shop mountFromData ' + shop.slug)
    // console.log(data)
  }

  function loadSettings() {
    // console.log('cart loadSettings checkoutStep 1 ' + checkoutStep)
    checkoutStep = $cart[shop.id].checkoutStep || ADDRESS
    // console.log('cart loadSettings checkoutStep 2 ' + checkoutStep)
    // console.log('cart loadSettings order.status ' + $cart[shop.id].currentOrder.status)
  }

  function saveSettings() {
    $cart[shop.id].checkoutStep = checkoutStep
  }

  onMount(async () => {
    mountFromData(shop)

    if ($cart[shop.id].currentOrder) {
      let orderStatus = $cart[shop.id].currentOrder.status
      // console.log('orderStatus:' + orderStatus)
      showCheckout = true
      doneAddress = orderStatus === 'checkout_address' || orderStatus === 'checkout_delivery' || orderStatus === 'checkout_payment'
      doneDelivery = orderStatus === 'checkout_delivery' || orderStatus === 'checkout_payment'
      donePayment = orderStatus === 'checkout_payment'
      loadSettings()
    }
  })

  function remove(kich) {
    console.log('removing: ' + kich)
    removeItem(kich, shop)

    if (!$cart[shop.id].items || !$cart[shop.id].items.length) {
      showSignup = false
      showCheckout = false
      if (emptied_handler) {
        emptied_handler()
      }
    }
  }

  function attemptCheckout() {
    // console.log('attemptCheckout ' + signedIn)

    showCheckout = true

    if (signedIn) {
      createOrder()
    } else {
      showSignup = true
      checkoutStep = ACCOUNT
    }
  }

  function cancelCheckout() {
    // console.log('cancelCheckout ' + signedIn)

    showCheckout = false

    // destroy current order!
    fetch(createPostRequest('/cart/checkout_delete.json',
                        "DELETE",
                        JSON.stringify({ slug: shop.slug, order_id: $cart[shop.id].currentOrder.id})))
      .then(response => {
        console.log('cancelCheckout:' + shop.slug)
      })
      .catch(err => {
        alert('error ' + err)
      })

    $cart[shop.id].currentOrder = null
  }

  function handle_checkout_address_done(order) {
    checkoutStep = DELIVERY
    doneAddress = true
    $cart[shop.id].currentOrder = order
    saveSettings()
  }

  function handle_checkout_delivery_done(order) {
    checkoutStep = PAYMENT
    doneDelivery = true
    $cart[shop.id].currentOrder = order
    saveSettings()
  }

  function handle_checkout_payment_done(order) {
    checkoutStep = SUBMIT
    donePayment = true
    $cart[shop.id].currentOrder = order
    saveSettings()
  }

  function handle_checkout_submit_done(order) {
    checkoutStep = ACCOUNT
    $cart[shop.id].currentOrder = null
    $cart[shop.id].items = []
    showCheckout = false
    saveSettings()

    if (order_done_handler) {
      order_done_handler(order)
    }
  }

  function handle_disable_canceling_order() {
    cancelingCheckoutEnabled = false
  }

  function handle_done_paying() {
    console.log('handle_done_paying')
    cancelingCheckoutEnabled = false
    donePaying = true

    $cart[shop.id].currentOrder = null
    $cart[shop.id].items = []
  }

  function createOrder() {
    let orderData = {
      items: $cart[shop.id].items.map((kich) => kich.id),
      currency: $settings.currency
    }

    fetch(createPostRequest('/cart/checkout_create.json',
                        'POST',
                        JSON.stringify({
                          order: orderData,
                          slug: shop.slug
                        })))
      .then(response => response.json())
      .then(data => {
        console.log('checkout_create ' + shop.slug)
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          errors = data.errors
        } else if (data.id) {

          // Order created!
          $cart[shop.id].currentOrder = data

          showSignup = false
          checkoutStep = ADDRESS

        } else {
          errors =["Something went wrong, try again later."]
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  function handle_signin(event) {
    if (event.detail.text === 'signedin') {
      dispatch('signin', {
        text: 'signedin',
        user_session: event.detail.user_session
      })
      if (showCart) { // the cart is showing, user just signed in from the cart
        createOrder()
      }
    }
  }

  function handle_tab_click(tab) {
    checkoutStep = tab
    console.log("handle_tab_click"  + checkoutStep)
    checkoutStep = signedIn ? tab : ACCOUNT

    if (checkoutStep === DELIVERY && !doneAddress) {
      checkoutStep = ADDRESS
    }

    if (checkoutStep === PAYMENT && !doneAddress) {
      checkoutStep = ADDRESS
    }

    if (checkoutStep === PAYMENT && doneAddress && !doneDelivery) {
      checkoutStep = DELIVERY
    }

    saveSettings()
  }

  $: itemsCount = $cart[shop.id]['items'].length
  $: total = $cart[shop.id]['items'].reduce((partialSum, { price }) => partialSum + +(price), 0)
  $: empty = !$cart[shop.id].items || !$cart[shop.id].items.length
</script>

<style>
</style>

<div class="cart w-full h-svh p-2">
  {#if showCheckout}
    {#if !donePaying}
      <div transition:slide={{ delay: 250, duration: 300, easing: quintOut, axis: 'x' }}>
      <div class="font-bold border-b-2">{$_('cart')}</div>
      <div class="flex flex-row justify-end gap-4 mt-1">
        <div class="flex items-center">{$_('items', {values: { n: itemsCount}})}: {formatCurrency(cartTotal(shop), $settings.locale, $settings.currency, 2, 0)}</div>
        {#if cancelingCheckoutEnabled}
          <div class="flex flex-col items-center">
            <button class="btn flex flex-col items-center" on:click={cancelCheckout}>
              <CheckoutIcon/>
              <span class="text-xs">Cancel</span>
            </button>
          </div>
        {/if}
      </div>
      </div>
    {/if}
  {:else}
    <div class="font-bold border-b-2">{$_('cart')}</div>
    {#if !$cart[shop.id].items || !$cart[shop.id].items.length}
      The cart is empty.
    {:else}
      <div class="flex flex-col gap-2 mt-1">
        {#if $cart[shop.id]['items']}
          {#each $cart[shop.id]['items'] as kich, index}
            <div class="flex flex-row items-center justify-end gap-2">
              <div class="kich-title {kich.kind}">{kich.title}</div>
              {#if kich.kind === 'tangible'}
                <div>{formatCurrency(kich.price, $settings.locale, $settings.currency, 2, 0)}</div>
              {:else}
                <div>{formatCurrency(0, $settings.locale, $settings.currency, 2, 0)}</div>
              {/if}
              <div><button class="btn flex flex-col items-center" on:click={() => remove(kich)}><RemoveIcon/><span class="text-xs">Remove</span></button></div>
            </div>
          {/each}
        {/if}
      </div>
      <div class="flex flex-col border-t-2 mt-1">
        <div class="flex flex-row justify-end gap-4 mt-1">
          <div class="flex items-center">{$_('total')}: {formatCurrency(cartTotal(shop), $settings.locale, $settings.currency, 2, 0)}</div>
          <div class="flex items-center"><button id="attempt-checkout" class="btn flex flex-col items-center" class:hidden={empty} on:click={attemptCheckout}><CheckoutIcon/><span class="text-xs">Checkout</span></button></div>
        </div>
      </div>
    {/if}
  {/if}

  {#if showCheckout}
    <div transition:slide={{ delay: 250, duration: 300, easing: quintOut, axis: 'x' }}>
    <div class="my-3 font-bold">{$_('checkout')}</div>
    <div class="checkout-tabs">
      <div class="tabs">
        <div class="tab {checkoutStep===ACCOUNT?'active':''} {signedIn?'done':'notdone'}" on:click={() => handle_tab_click(ACCOUNT)}>Account</div>
        <div class="tab {checkoutStep===ADDRESS?'active':''} {doneAddress?'done':'notdone'}" on:click={() => handle_tab_click(ADDRESS)}>Address</div>
        <div class="tab {checkoutStep===DELIVERY?'active':''} {doneDelivery?'done':'notdone'}" on:click={() => handle_tab_click(DELIVERY)}>Delivery</div>
        <div class="tab {(checkoutStep===PAYMENT||checkoutStep===SUBMIT)?'active':''} {donePayment?'done-payment':''} {donePaying?'done':'notdone'}" on:click={() => handle_tab_click(PAYMENT)}>Payment</div>
      </div>
      <div class="tabs-content">
        {#if showSignup}
          <div class="signup">
            <Signup {shop} bind:signedIn on:signin={handle_signin}/>
          </div>
        {:else}
          <div class="status">
            {#if checkoutStep === ACCOUNT}
              <div class="frame mt-3 flex flex-row justify-center">Your account is valid.</div>
            {:else if checkoutStep === ADDRESS}
              <CheckoutAddress bind:order={$cart[shop.id].currentOrder} bind:shop {signedIn} done_handler={handle_checkout_address_done}/>
            {:else if checkoutStep === DELIVERY}
              <CheckoutDelivery bind:order={$cart[shop.id].currentOrder} bind:shop {signedIn} done_handler={handle_checkout_delivery_done}/>
            {:else if checkoutStep === PAYMENT}
              <CheckoutPayment bind:order={$cart[shop.id].currentOrder} bind:shop {signedIn} done_handler={handle_checkout_payment_done}/>
            {:else if checkoutStep === SUBMIT}
              <CheckoutSubmit bind:order={$cart[shop.id].currentOrder} bind:shop {signedIn} done_handler={handle_checkout_submit_done} disable_canceling_order_handler={handle_disable_canceling_order} done_paying_handler={handle_done_paying}/>
            {/if}
          </div>
        {/if}
      </div>
    </div>
    </div>
  {/if}
</div>